/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProjectFolderDto,
    ProjectFolderDtoFromJSON,
    ProjectFolderDtoFromJSONTyped,
    ProjectFolderDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectFolderResponse
 */
export interface ProjectFolderResponse {
    /**
     * 
     * @type {Array<ProjectFolderDto>}
     * @memberof ProjectFolderResponse
     */
    all: Array<ProjectFolderDto>;
    /**
     * 
     * @type {number}
     * @memberof ProjectFolderResponse
     */
    totalCount: number;
}

export function ProjectFolderResponseFromJSON(json: any): ProjectFolderResponse {
    return ProjectFolderResponseFromJSONTyped(json, false);
}

export function ProjectFolderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectFolderResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'all': ((json['all'] as Array<any>).map(ProjectFolderDtoFromJSON)),
        'totalCount': json['totalCount'],
    };
}

export function ProjectFolderResponseToJSON(value?: ProjectFolderResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'all': ((value.all as Array<any>).map(ProjectFolderDtoToJSON)),
        'totalCount': value.totalCount,
    };
}


